import Wahanda from 'common/wahanda';

export default function formatPrice(price) {
  return Wahanda.Currency.format(price);
}
